import { useLocation } from 'react-router-dom';
import { useMe } from '../lib/me';

/**
 * 정산 화면 맨 위의 범위 안내(2026-09-27 — 담당자별 정산 보기).
 * 범위가 걸려 있으면 **그렇다고 말한다** — 조용히 좁히면 "자료가 없어졌다"는 신고가 되고,
 * 그때 원인이 필터라는 걸 아무도 못 찾는다(배차 화면 `scopeNote` 와 같은 판단).
 * 전량을 보는 사람(회계·관리자·범위 전체)과 스위치가 꺼진 동안에는 아무것도 안 뜬다.
 */
const SETTLE_PATHS = ['/settle', '/result-daily', '/result-mo', '/result-req', '/fin-inst', '/invoice-status'];

export default function SettleScopeNote() {
  const { me } = useMe();
  const { pathname } = useLocation();
  if (!me?.settleScopeNote || !SETTLE_PATHS.some((p) => pathname.startsWith(p))) return null;
  return (
    <p className="mb-2 inline-block break-keep rounded-lg bg-amber-50 px-2.5 py-1.5 text-xs text-amber-800">
      {me.settleScopeNote}
      {me.role !== 'admin' && ' 범위를 넓히려면 관리자에게 요청하세요.'}
    </p>
  );
}
